/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import {useFocusEffect} from '@react-navigation/native';
import React from 'react';
import {useEffect} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';
import { AccountServices } from '../../../services/applicatif/account';
import mapDispatchToProps from '../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../services/redux/mapStateToProps';
import { styles } from './styles';
import { MenuItem } from '../../components/MenuItem';
import { liste } from '../../../data/constants/monEspace';
import { HeaderScreen } from '../../components/Header/HeaderScreen';


export const MonEspaceScreen = (props: any) => {
  const {user, notificationNotSeenUser, signOutUser, navigate} = props;

  const getNotification = (id: string) => {
    notificationNotSeenUser({}, () => {}, `${id}`);
  };

  const handleLogout = () => {
    signOutUser({}, () => {
      navigate('Home');
    });
  };

  useEffect(() => {
    user?.data?.utilisateur?.id && getNotification(user.data.utilisateur.id);
  }, [user.numberNotificationNotSeen]);

  useFocusEffect(React.useCallback(() => {
    AccountServices().checkAccount(user?.data?.utilisateur?.email, 'TestsToDelete12345')
    .then((res: any) => {
      if (res.isError && res.message === 'Email non trouvé dans la base ou utilisateur inactif') {
        handleLogout();
      }
    });
  }, []));

  return (
    <View style={styles.container}>
      <HeaderScreen title="Compte" type="home" noBreadcrumb={false} />
      <MenuItem
        numberNotification={
          user &&
          user.data &&
          user.data.utilisateur &&
          user.numberNotificationNotSeen > 0
            ? user.numberNotificationNotSeen
            : 0
        }
        data={liste}
        isHome={false}
      />
    </View>
  );
}

export const MonEspace: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MonEspaceScreen);
